import { Stack } from "@mui/material";
import Chip from "components/Chip";
import { cn } from "utils/styling";

import {
  COUNTED_JOB_LOG_LEVELS,
  type CountedJobLogLevel,
  JOB_LOG_LEVELS,
  type JobLogLevel,
  jobLogLevelDotClass,
} from "../model/jobLogLevels";

type TransientJobLogLevelChipsProps = {
  counts: Record<CountedJobLogLevel, number>;
  onSelect: (level: JobLogLevel) => void;
  selected: JobLogLevel;
};

const hasCount = (level: JobLogLevel): level is CountedJobLogLevel =>
  COUNTED_JOB_LOG_LEVELS.some((item) => item === level);

export const TransientJobLogLevelChips = ({ counts, onSelect, selected }: TransientJobLogLevelChipsProps) => {
  return (
    <Stack className="gap-2">
      {JOB_LOG_LEVELS.map((level) => (
        <Chip className="gap-2" isOn={selected === level} key={level} onClick={() => onSelect(level)}>
          <span className={cn("h-2 w-2 rounded-full", jobLogLevelDotClass(level))} />
          <span>{level}</span>
          {hasCount(level) ? <span>({counts[level]})</span> : null}
        </Chip>
      ))}
    </Stack>
  );
};
